import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";

import { useCurrentProduct } from "./useCurrentProduct";
import { designControlsApi } from "../api/designControls";

export const useRetrieveDesignElementVersions = (
  designElementId: string,
  enabled = true,
) => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  return useQuery({
    queryKey: [
      "DESIGN_ELEMENT_VERSIONS",
      companyId,
      productId,
      designElementId,
    ],
    queryFn: () =>
      designControlsApi.retrieveDesignElementVersions(
        companyId,
        productId,
        designElementId,
      ),
    enabled,
  });
};
